// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import { TabDefinition } from "@insite/client-framework/Types/TabDefinition";
import { useCallback, useState } from "react";

export enum fields {
    enableImageHover = "enableImageHover",
    transitionDuration = "transitionDuration",
    transitionTimingFunction = "transitionTimingFunction",
}
export default function useSecondImageOnHover(originalProductContext: ProductContextModel) {
    const [isHovered, setIsHovered] = useState(false);

    const onMouseEnter = useCallback(() => {
        setIsHovered(true);
    }, []);

    const onMouseLeave = useCallback(() => {
        setIsHovered(false);
    }, []);

    const product = originalProductContext.product;

    const hoverImage = product.images?.slice(1).find(image => {
        return !image.name.toLowerCase().includes("sizechart");
    });

    const hasSecondImage = !!hoverImage;

    const hoverImageProductContext = hasSecondImage
        ? {
              ...originalProductContext,
              product: {
                  ...product,
                  smallImagePath: hoverImage.smallImagePath ?? product.smallImagePath,
                  mediumImagePath: hoverImage.mediumImagePath ?? product.mediumImagePath,
                  largeImagePath: hoverImage.largeImagePath ?? product.largeImagePath,
              },
          }
        : originalProductContext;

    const handlers = {
        onMouseEnter,
        onMouseLeave,
    };

    return {
        handlers,
        isHovered,
        hasSecondImage,
        hoverImageProductContext,
    };
}

const hoverTab: TabDefinition = {
    displayName: "Hover",
    sortOrder: 10,
};
export const imageHoverOptions: FieldDefinition[] = [
    {
        name: fields.enableImageHover,
        displayName: "Enable Image Hover",
        editorTemplate: "CheckboxField",
        defaultValue: false,
        fieldType: "General",
        sortOrder: 15,
        tab: hoverTab,
    },
    {
        name: fields.transitionDuration,
        displayName: "Transition Duration",
        editorTemplate: "IntegerField",
        defaultValue: 500,
        fieldType: "General",
        isVisible: fields => fields.fields.enableImageHover,
        sortOrder: 16,
        tab: hoverTab,
    },
    {
        name: fields.transitionTimingFunction,
        displayName: "Transition Timing Function",
        editorTemplate: "DropDownField",
        defaultValue: "ease-in-out",
        isVisible: fields => fields.fields.enableImageHover,
        options: [
            { displayName: "Ease", value: "ease" },
            { displayName: "Ease-In", value: "ease-in" },
            { displayName: "Ease-Out", value: "ease-out" },
            { displayName: "Ease-In-Out", value: "ease-in-out" },
            { displayName: "Linear", value: "linear" },
            { displayName: "Step-Start", value: "step-start" },
            { displayName: "Step-End", value: "step-end" },
        ],
        fieldType: "General",
        sortOrder: 17,
        tab: hoverTab,
    },
];
